import React from 'react';

import GrommetSelect from 'grommet/components/Select';

export default class Select extends React.Component {
  constructor(props) {
    super(props);

    this.onSearch = this.onSearch.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      value: props.value,
      options: props.options,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hasOwnProperty('value')) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange({ option, target }) {
    this.setState({ value: option, options: this.props.options }, () => {
      if (this.props.onChange) this.props.onChange({ option, target });
    });
  }

  onSearch({ target: { value } }) {
    const { options } = this.props;
    const nextOptions = options.filter(o => {
      return o.toLowerCase().indexOf(value.toLowerCase()) > -1;
    });

    this.setState({ options: nextOptions });
  }
  render() {
    return (
      <GrommetSelect
        {...this.props}
        value={this.state.value}
        options={this.state.options}
        onSearch={this.onSearch}
        onChange={this.onChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/elements/Select.js